module.exports = __webpack_public_path__ + "img/subscription-trigger-hover.aa4d0a5c.png";